var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropoffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 49,
    viewBox: "0 0 36 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.666504C8.0595 0.666504 0 8.726 0 18.6665C0 22.5808 1.28325 26.1725 3.41625 29.114C3.4545 29.1845 3.4605 29.2633 3.504 29.3308L15.504 47.3308C16.0605 48.1655 16.998 48.6665 18 48.6665C19.002 48.6665 19.9395 48.1655 20.496 47.3308L32.496 29.3308C32.5402 29.2633 32.5455 29.1845 32.5838 29.114C34.7168 26.1725 36 22.5808 36 18.6665C36 8.726 27.9405 0.666504 18 0.666504ZM18 24.6665C14.6865 24.6665 12 21.98 12 18.6665C12 15.353 14.6865 12.6665 18 12.6665C21.3135 12.6665 24 15.353 24 18.6665C24 21.98 21.3135 24.6665 18 24.6665Z",
    fill: "#F37A50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropoffIcon);
export default __webpack_public_path__ + "static/media/dropoff-icon.814676ab9af2615613f02f2186855bcc.svg";
export { ForwardRef as ReactComponent };